export var HEX = 'HEX';
export var RGBA = 'RGBA';
